<script lang="ts">

    export let selected: string = '';
    export let items: {id: string, label: string}[] = [];
</script>

<div>
    <select name="warehouse" bind:value={selected} class="input-small" on:change >
        {#each items as item}
            <option value={item.id}>{item.label}</option>
        {/each}
    </select>
</div>

<style>
    .input-small {
        /*padding: 4px;*/
        /*border: 1px solid #ccc;*/
        /*border-radius: 5px;*/
        background-color: white;
        width: 170px;
        padding: var(--input-small-padding);
        border: var(--input-small-border);
        color: var(--input-small-color);
        border-radius: var(--input-small-border-radius);
    }
</style>